import { BlockStack, Box, InlineStack, SkeletonBodyText } from '@shopify/polaris';
import GEMX_LOGO from '~/presentation/assets/svg/gemx-skeleton.svg';
import { GInlineCenter } from '~/presentation/ui';

export const ReportChartSkeleton = () => {
  return (
    <div className="p-4 pr-8">
      <BlockStack gap="400">
        <Box width="133px" paddingBlock="200" paddingInline="100">
          <SkeletonBodyText lines={1} />
        </Box>
        <GInlineCenter align="center" inlineAlign="center" minHeight="330px">
          <img src={GEMX_LOGO} alt="Gemx" width={38} height={42} />
        </GInlineCenter>
        <InlineStack gap="800" align="center" blockAlign="center">
          <Box width="92px">
            <SkeletonBodyText lines={1} />
          </Box>
          <Box width="92px">
            <SkeletonBodyText lines={1} />
          </Box>
        </InlineStack>
      </BlockStack>
    </div>
  );
};
